import { InjectionToken } from '@angular/core';
import { ListRendererModuleConfig } from '../interfaces/list-renderer-module-config';

export const LIST_RENDERER_MODULE_CONFIG = new InjectionToken<ListRendererModuleConfig>('List renderer module config');
